import { ArrowLeftRight } from "lucide-react";

import { Button } from "@/components/button";
import { useGetBrandById } from "@/features/brands/shared/hooks/useGetBrandById";
import { MBCTitleBar } from "@/features/request/mbc-review/components/MBCTitleBar";
import { useDesignTypeName } from "@/features/request/mbc-review/useDesignTypeName";

type MBCChatHeaderProps = {
  brandId?: number;
  designType?: number;
  isTeamMember?: boolean;
  onBack?: () => void;
  onRename?: (name: string) => void;
  onSwitchToClassic?: () => void;
  requestName?: string;
};

export function MBCChatHeader({
  brandId,
  designType,
  isTeamMember = false,
  onBack,
  onRename,
  onSwitchToClassic,
  requestName = "Untitled brief",
}: MBCChatHeaderProps) {
  const designTypeName = useDesignTypeName(designType);
  const { data: brand } = useGetBrandById(brandId ?? 0);

  return (
    <MBCTitleBar
      actions={
        isTeamMember && onSwitchToClassic ? (
          <Button
            aria-label="Switch to Classic Brief Form"
            onPress={onSwitchToClassic}
            size="sm"
            variant="secondary"
          >
            <ArrowLeftRight className="size-4" />
            <span className="hidden md:inline">
              Switch to Classic Brief Form
            </span>
          </Button>
        ) : null
      }
      brand={brand ? { logoUrl: brand.profilePicture, name: brand.name } : null}
      designTypeName={designTypeName}
      onBack={onBack}
      onTitleSave={onRename}
      title={requestName}
    />
  );
}
